export default __webpack_public_path__ + "static/media/just_hand.26d710e2.png";